import React, { FC } from 'react';
import ResolveHeader from 'components/ResolveHeader';
import { UploadImSuccessful } from 'components/UploadImSuccessful';
import { UploadImSuccessfulProps } from 'components/UploadImSuccessful/UploadImSuccessful.component';

import './UploadImSuccessful.styles.scss';

const UploadImSuccessfulPage: FC<UploadImSuccessfulProps> = (props) => (
  <div className="upload-im-page">
    <ResolveHeader />
    <main>
      <UploadImSuccessful {...props} />
    </main>
  </div>
);

export default UploadImSuccessfulPage;
